const { getRfidEnabledRelations } = require('./rfidEnabledRelations');
module.exports = {
    // Keep first: Node's ESM named-export detection stops after the first `key: require()` entry.
    getRfidEnabledRelations,
    helpers: require('./helpers'),
    config: require('./config'),
    getAccessRestrictions: require('./getAccessRestrictions'),
    moduleRegistration: require('./moduleRegistration'),
    writeRequirements: require('./writeRequirements'),
    actionUtils: require('./actionUtils')
};
